import "D:\\qianduan\\residents-move\\node_modules\\core-js\\modules\\es.array.iterator.js";
import "D:\\qianduan\\residents-move\\node_modules\\core-js\\modules\\es.promise.js";
import "D:\\qianduan\\residents-move\\node_modules\\core-js\\modules\\es.object.assign.js";
import "D:\\qianduan\\residents-move\\node_modules\\core-js\\modules\\es.promise.finally.js";
import Vue from "vue";
import App from "./index.vue";
Vue.config.productionTip = false;
new Vue({
  el: "#app",
  render: function render(h) {
    return h(App);
  }
});